// extracted by mini-css-extract-plugin
export default {"tupacGrid":"xl-z","tupacHeader":"yl-z","tupacHeader2":"zl-z","tupacMenu":"Al-z","tupacMenu2":"Bl-z","tupacMain":"Cl-z","tupacMain2":"Dl-z"};